import React, { useEffect } from 'react';
import EditLicensePlateLayout from 'feature/license-plates/edit-license-plate-layout';
import {
  useLicensePlateContext,
  CHANGE_PLATE_NUMBER,
  CHANGE_CAR_TYPE,
  INITIALIZE,
} from 'feature/license-plates/use-license-plate';
import { CAR_TYPE } from 'model/license-plate';
import amplitude from 'service/amplitude';

const NewLicensePlate = () => {
  const { state, dispatch, addLicensePlate, redirectAfterAddPlate } = useLicensePlateContext();

  useEffect(() => {
    dispatch({ type: INITIALIZE, payload: { plateNumber: '', vehicleType: 'car' } });
  }, []);

  const onTextChanged = text => {
    dispatch({ type: CHANGE_PLATE_NUMBER, payload: text });
  };

  const onTypeChanged = type => {
    amplitude.plateNumber_add_type_onClick();
    dispatch({ type: CHANGE_CAR_TYPE, payload: type });
  };

  const onFocus = () => amplitude.plateNumber_add_plate_onClick();

  const onSubmit = () => {
    amplitude.plateNumber_add_complete_onClick();
    addLicensePlate({ payload: state });
  };

  return (
    <EditLicensePlateLayout
      plateNumber={state.plateNumber}
      vehicleType={CAR_TYPE.key}
      onTextChanged={onTextChanged}
      errorMessage={state.plateNumberErrorMessage}
      onRadioClick={onTypeChanged}
      onClick={onSubmit}
      onFocus={onFocus}
      btnLoading={state.loading}
      rentalPlateDialogShow={state.showRentalPlateDialog}
      rentalPlateDialogOnClick={redirectAfterAddPlate}
    />
  );
};

export default NewLicensePlate;
